import {
  createDomainListReduxUtil,
  WORKOUT_DEFAULT_TAG_FILTER
} from '@gymaholic/packages'

const WORKOUTS_DOMAIN = 'workouts'
const WORKOUT_EXERCISES_DOMAIN = 'workoutExercises'
const WORKOUTS_ACTION = {
  LOAD_RECOMMENDED: 'WORKOUTS_LOAD_RECOMMENDED',
  LOAD_RECOMMENDED_BY_ID: 'WORKOUTS_LOAD_RECOMMENDED_BY_ID',
  LOAD_BY_ID: 'WORKOUTS_LOAD_BY_ID',
  LOAD_BY_SHARE_KEY: 'WORKOUTS_LOAD_BY_SHARE_KEY',
  SAVE_COMPLETED_WORKOUT_REVIEW: 'SAVE_COMPLETED_WORKOUT_REVIEW'
}

const WORKOUTS_ENDPOINT = {
  LOAD_RECOMMENDED: '/workouts/recommended',
  LOAD_RECOMMENDED_BY_ID: '/workouts/recommended/:id',
  LOAD_BY_SHARE_KEY: '/workouts/shared/:shareKey',
  LOAD_BY_ID: '/workouts/:id',
  REVIEW: '/workouts/:id/review',
  PROFILES_WHO_STARTED: '/workouts/:id/profiles-who-started'
}

const WORKOUTS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  STARTED: 'started',
  TAG: 'tag',
  SMART: 'smart',
  SUGGESTED: 'suggested',
  DATA: 'data',
  LOGGED: 'logged',
  NON_LOGGED: 'nonLogged',
  PLANNED: 'planned',
  RECOMMENDED: 'recommended'
}

const WORKOUTS_PATH = {
  ALL: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.ALL}`,
  ALL_DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.ALL}.data`,
  CURRENT: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.CURRENT}`,
  STARTED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.STARTED}`,
  TAG: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.TAG}`,
  DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.DATA}`,
  LOGGED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.LOGGED}`,
  LOGGED_DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.LOGGED}.data`,
  NON_LOGGED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.NON_LOGGED}`,
  NON_LOGGED_DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.NON_LOGGED}.data`,
  PLANNED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.PLANNED}`,
  PLANNED_DATA: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.PLANNED}.data`,
  SMART: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.SMART}`,
  SMART_VALUE: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.SMART}.value`,
  SMART_STATUS: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.SMART}.status`,
  SMART_ERROR: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.SMART}.error`,
  SUGGESTED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.SUGGESTED}`,
  RECOMMENDED: `${WORKOUTS_DOMAIN}.${WORKOUTS_KEY.RECOMMENDED}`
}

const WORKOUT_SET_DATA_MODAL_TYPES = {
  SET_VALUE: 'setValue',
  SET_TYPE: 'setType',
  SET_WEIGHT: 'setWeight'
}

const WORKOUTS_STATE = {
  [WORKOUTS_KEY.ALL]: createDomainListReduxUtil(),
  [WORKOUTS_KEY.LOGGED]: createDomainListReduxUtil(),
  [WORKOUTS_KEY.NON_LOGGED]: createDomainListReduxUtil(),
  [WORKOUTS_KEY.PLANNED]: createDomainListReduxUtil(),
  [WORKOUTS_KEY.CURRENT]: null,
  [WORKOUTS_KEY.STARTED]: null,
  [WORKOUTS_KEY.TAG]: WORKOUT_DEFAULT_TAG_FILTER,
  [WORKOUTS_KEY.SUGGESTED]: null,
  [WORKOUTS_KEY.SMART]: {
    value: null,
    status: null,
    error: null
  },
  [WORKOUTS_KEY.DATA]: {},
  [WORKOUTS_KEY.RECOMMENDED]: {
    ...createDomainListReduxUtil(),
    byTag: createDomainListReduxUtil(),
    byQuery: createDomainListReduxUtil()
  }
}

export {
  WORKOUTS_ACTION,
  WORKOUTS_ENDPOINT,
  WORKOUTS_DOMAIN,
  WORKOUTS_STATE,
  WORKOUTS_KEY,
  WORKOUTS_PATH,
  WORKOUT_EXERCISES_DOMAIN,
  WORKOUT_SET_DATA_MODAL_TYPES
}
